export default {"src":"/_next/static/media/profile.a9263714.svg","height":400,"width":240,"blurWidth":0,"blurHeight":0};